import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchMasters, fetchAgeingBands } from './api';

const MastersContext = createContext();
export const useMasters = () => useContext(MastersContext);

export const MastersProvider = ({ children }) => {
  const [masters, setMasters] = useState({
    products: [],
    tests: [],
    stages: [],
    stabilityConditions: [],
    markets: [],
    durations: [],
    analysisTypes: [],
  });
  const [ageingBands, setAgeingBands] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMasters = useCallback(async () => {
    try {
      setLoading(true);
      const [mastersData, bandsData] = await Promise.all([
        fetchMasters(),
        fetchAgeingBands(),
      ]);
      setMasters(mastersData);
      setAgeingBands(bandsData);
    } catch (err) {
      console.error('Failed to load masters:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMasters();
  }, [loadMasters]);

  const refreshMasters = useCallback(() => loadMasters(), [loadMasters]);

  return (
    <MastersContext.Provider value={{ masters, ageingBands, loading, refreshMasters }}>
      {children}
    </MastersContext.Provider>
  );
};
